import React, { useState } from 'react'
import './Navbar.scss'
import { HiMenuAlt4, HiX } from 'react-icons/hi'
import { motion } from 'framer-motion';

import { images } from '../../constants'

function Navbar() {
	const [toggle, setToggle] = useState(false);

	return (
		<nav className='app__navbar'>
			<a href='#home' className='app__navbar-logo'>
					<img src={images.logo} alt='logo' />
			</a>
			<ul className='app__navbar-links'>
				{
					['home', 'technologies', 'projects', 'skills', 'contact'].map((item) => (
						<li className='app__flex p2-text' key={`link-${item}`}>
							<div />
							<a href={`#${item}`}>{item}</a>
						</li>
					))
				}
			</ul>
			<div className='app__navbar-menu'>
				<HiMenuAlt4 onClick={() => setToggle(true)} />

				{toggle && (
					<motion.div
						whileInView={{ x: [300, 0] }}
						transition={{ duration: 0.85, ease: 'easeOut' }}
					>
						<HiX onClick={() => setToggle(false)} />
						<ul>
							{
								['home', 'technologies', 'projects', 'skills', 'contact'].map((item) => (
									<li key={item}>
										<a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
									</li>
								))
							}
						</ul>
					</motion.div>
				)}
			</div>
		</nav>
	)
}

export default Navbar